interface ChevronDownProps {
  color?: string
  size?: number
}

function ChevronDown({color = "currentColor", size = 24}: ChevronDownProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.5 8L12.25 15L21 8" stroke={color} stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    
  )
}

export default ChevronDown